"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProviders = exports.isOrderPaymentConfirmed = exports.OrderStatus = exports.paymentStatuses = void 0;
var paymentStatuses;
(function (paymentStatuses) {
    paymentStatuses[paymentStatuses["unknown"] = 0] = "unknown";
    paymentStatuses[paymentStatuses["pending"] = 1] = "pending";
    paymentStatuses[paymentStatuses["processing"] = 2] = "processing";
    paymentStatuses[paymentStatuses["succeeded"] = 3] = "succeeded";
    paymentStatuses[paymentStatuses["cancelled"] = 4] = "cancelled";
    paymentStatuses[paymentStatuses["failed"] = 5] = "failed";
    paymentStatuses[paymentStatuses["paid_offline"] = 6] = "paid_offline";
})(paymentStatuses || (exports.paymentStatuses = paymentStatuses = {}));
exports.OrderStatus = {
    PENDING_PAYMENT: 'pending_payment',
    IN_PROGRESS: 'in_progress',
    COMPLETE: 'complete',
    CANCELLED: 'cancelled',
    FAILED: 'failed',
};
var isOrderPaymentConfirmed = function (status) {
    return status === exports.OrderStatus.IN_PROGRESS || status === exports.OrderStatus.COMPLETE;
};
exports.isOrderPaymentConfirmed = isOrderPaymentConfirmed;
exports.PaymentProviders = {
    STRIPE: 'Stripe',
    STRIPE_LEGACY: 'Stripe-Legacy',
    DATATRANS: 'Datatrans',
    MOCK: 'Mock',
};
